var React = require('react');

function Bus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M59.837 13.653H59V7.959c-.429-2.088-2.059-4.305-4.052-4.928C54.948 3.031 48.449 1 32 1S9.052 3.031 9.052 3.031C7.059 3.654 5.429 5.871 5 7.959v5.694h-.837A3.172 3.172 0 001 16.816v7.592a3.172 3.172 0 003.163 3.163H5V56h2.327v1.306C7.327 60.438 9.889 63 13.02 63c3.132 0 5.694-2.562 5.694-5.694V56h26.571v1.306c0 3.132 2.562 5.694 5.694 5.694s5.694-2.562 5.694-5.694V56H59V27.571h.837A3.172 3.172 0 0063 24.408v-7.592a3.172 3.172 0 00-3.163-3.163zM22 5h20v5H22V5zm-8.98 46.612a3.163 3.163 0 11.001-6.327 3.163 3.163 0 01-.001 6.327zM10 38V14h44v24H10zm40.98 13.612a3.163 3.163 0 11.001-6.327 3.163 3.163 0 01-.001 6.327z"}));
}

Bus.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = Bus;

Bus.default = Bus;
